<script>
    import { slide } from 'svelte/transition';
    import { createEventDispatcher } from "svelte";
    import tippy from "sveltejs-tippy";
    const dispatch = createEventDispatcher();

    export let text;
    let tippyInst;

    function resetContent() {
        tippyInst.setContent('Copy to clipboard');
    }

    function copyToClipboard() {
        navigator.clipboard.writeText(text).then(
            () => { tippyInst.setContent('Copied!'); dispatch('copySucceeded') },
            (e) => dispatch('copyFailed', {'error': e})
        );
    }

</script>

<style>
    button {
        background-image: url("assets/svg/copy.svg");
        background-position: center;
        background-repeat: no-repeat;
        border: none;
        background-color: transparent;
        background-size: contain;
        display: inline-block;
        cursor: pointer;
        margin: 0;
        padding: 0;
        width: 1.5rem;
    }
</style>
    
<button use:tippy={{
        onMount: (inst) => { tippyInst = inst; resetContent(); },
        onHidden: () => resetContent(),
        hideOnClick: false
    }}
    title="Copy to clipboard"
    class="hovery"
    on:click={copyToClipboard}
    in:slide>&nbsp;</button>